export { default } from './components/AskMeDetail'
